module.exports = __webpack_public_path__ + "img/Psych_text04c_goalpsych.2a2984cb.png";